import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-content-head" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_3 = {
  key: 0,
  "data-qa": "project-user-pledge:PreviousPledges"
}
const _hoisted_4 = {
  class: "gfu-hd gfu-hd--h1 _mt-6",
  "data-qa": "page-title"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "_mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_legacy_project_user_pledge = _resolveComponent("legacy-project-user-pledge")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-layout-wrapper', _ctx.firstPledge ? 'gfu-layout-wrapper--narrow' : 'gfu-layout-wrapper--extranarrow', '_pb-4'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoaded)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString($options.pageTitle), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.firstPledge && $options.project)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_legacy_project_user_pledge, {
            "initial-expanded-state": true,
            "is-open-for-orders": $props.isOpenForOrders,
            pledge: _ctx.firstPledge,
            "add-new-items-url": $props.addNewItemsUrl,
            project: $options.project,
            onCartTableLoaded: $options.onCurrentPledgeTableLoaded,
            onPledgeChanged: $options.onPledgeChanged,
            "data-qa": "project-user-pledge:CurrentPledge"
          }, null, 8 /* PROPS */, ["is-open-for-orders", "pledge", "add-new-items-url", "project", "onCartTableLoaded", "onPledgeChanged"]),
          ($options.previousPledges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString($options.previousOrdersLabel), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.previousPledges, (pledge) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `pledge-${pledge.orderID}`,
                    ref_for: true,
                    ref: `pledge-${pledge.orderCode}`
                  }, [
                    _createVNode(_component_legacy_project_user_pledge, {
                      "is-open-for-orders": $props.isOpenForOrders,
                      pledge: pledge,
                      "is-expandable": true,
                      "add-new-items-url": $props.addNewItemsUrl,
                      "initial-expanded-state": pledge.orderCode === $props.selectedOrderCode,
                      project: $options.project,
                      onPledgeChanged: $options.onPledgeChanged,
                      "data-qa": `project-previous-user-pledge:${pledge.orderID}`
                    }, null, 8 /* PROPS */, ["is-open-for-orders", "pledge", "add-new-items-url", "initial-expanded-state", "project", "onPledgeChanged", "data-qa"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.isLoaded)
        ? (_openBlock(), _createBlock(_component_box, {
            key: 1,
            class: "_mt-3",
            "data-qa": "project-user-pledge:EmptyState"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_empty_state, {
                title: _ctx.Resources.YourPledge.EmptyPledgeTitle,
                description: $props.emptyStateDescription
              }, {
                default: _withCtx(() => [
                  ($props.isOpenForOrders)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $props.addNewItemsUrl,
                        class: "gfu-btn gfu-btn--accent gfu-btn--soft",
                        "data-qa": "project-user-pledge-button:AddItems"
                      }, _toDisplayString($options.emptyStateButtonText), 9 /* TEXT, PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title", "description"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
    _createElementVNode("aside", _hoisted_6, [
      _createVNode(_component_project_recommendations, {
        title: _ctx.Resources.ProjectHome.ProjectRecommendationsTitle,
        "exclude-project-ids": [_ctx.projectContext.project.projectID],
        quantity: 12,
        source: "your-pledge",
        "data-qa": `Recommendations`
      }, null, 8 /* PROPS */, ["title", "exclude-project-ids"])
    ]),
    _createVNode(_component_progress_overlay, {
      visible: $setup.isProcessingView,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ], 2 /* CLASS */))
}